import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import BranchAgentTicketsPerService from "../../../components/branches/reports/daily/BranchAgentTicketsPerService";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
} from "../../../store/renderConfig";

const asArray = (data) => (Array.isArray(data) ? data : [data]);

const AgentTicketsPerService = ({
  reportIndex = "**REPORT_INDEX**",
}) => (
  <DailyGeneratedReportPage
    columnDefinitions={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
    descriptionKey="AgentTicketsByService"
    normalizeData={asArray}
    title={`${reportIndex}. Agent Tickets Per Service`}
  >
    {({ data, renderConfig }) => (
      <BranchAgentTicketsPerService reportIndex={reportIndex} data={data} renderConfig={renderConfig} />
    )}
  </DailyGeneratedReportPage>
);

export default AgentTicketsPerService;
